const parseUsername = function(username) {
	username = username.match(/(.*)\s\((.*)\)\s(.*)/)
	let first = username[1],
		firstPlural = username[1].endsWith('s') ? `${username[1]}'` : `${username[1]}'s`,
        fullPlural = username[3].endsWith('s') ? `${username[3]}'` : `${username[3]}'s`,
		last = username[3],
		nickname = username[2]
	return { first, firstPlural, fullPlural, last, nickname }
}

export default parseUsername
